module.exports = __webpack_public_path__ + "static/media/payson.7a723ad3.svg";